import types from '../actions/types';

import {
    paginatedResultReducer
} from './common/paginated_results';
import {
    singleResultInitialState
} from './common/single-result';


const initial_state = {
    invoice: singleResultInitialState
}

export default function(state = initial_state, action) {
    switch (action.type) {

        default:
            return {
                ...state,
                invoices: paginatedResultReducer(state.promoCodes, types.ADMIN_LOAD_INVOICES, action)
            };
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/invoices.js